import { cn } from '../../lib/utils';
import { Icon } from '@iconify/react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  color?: 'primary' | 'muted' | 'white';
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6', 
  lg: 'h-8 w-8',
  xl: 'h-16 w-16'
};

const colorClasses = {
  primary: 'text-orange-500',
  muted: 'text-muted-foreground',
  white: 'text-white'
};

export function Spinner({ size = 'md', className, color = 'primary' }: SpinnerProps) {
  const sizeClass = sizeClasses[size];
  const colorClass = colorClasses[color];
  
  return (
    <Icon 
      icon="hugeicons:loading-03"
      className={cn('animate-spin', sizeClass, colorClass, className)}
    />
  );
}

export function LoadingSpinner({ 
  size = 'lg', 
  message = 'Loading...', 
  subMessage,
  className 
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  message?: string;
  subMessage?: string;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div className="text-center">
        <Spinner size={size} className="mx-auto mb-4" />
        <p className="text-foreground text-lg font-medium">{message}</p>
        {subMessage && (
          <p className="text-muted-foreground text-sm mt-1">{subMessage}</p>
        )}
      </div>
    </div>
  );
}